import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { EditorModule } from '@progress/kendo-angular-editor';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { TranslationModule } from '../shared/translation/translation.module';
import { AdminViewComponent } from './admin-view.component';
import { KeywordsViewComponent } from './keywords-view/keywords-view.component';
import { EditKeywordComponent } from './keywords-view/edit-keyword/edit-keyword.component';
import { EditCategoryComponent } from './keywords-view/edit-category/edit-category.component';
import { DescriptionsViewComponent } from './keywords-view/descriptions-view/descriptions-view.component';
import { TeamsViewComponent } from './teams-view/teams-view.component';
import { EditTeamComponent } from './teams-view/edit-team/edit-team.component';
import { EditSupporterComponent } from './teams-view/edit-supporter/edit-supporter.component';
import { CanDeactivateGuard } from '../can-deactivate.guard';
import { TeamsViewService } from './teams-view/teams-view.service';
import { TranslationsViewComponent } from './translations-view/translations-view.component';
import { SafePipe } from '../shared/safe-pipe/safe-pipe';
import { EmailTranslationsViewComponent } from './email-translations-view/email-translations-view.component';
import { TeamsFiltersComponent } from './teams-view/teams-filters/teams-filters.component';
import { TranslatePipe } from '../shared/translation/translation.pipe';

@NgModule({
  declarations: [
    AdminViewComponent,
    KeywordsViewComponent,
    TranslationsViewComponent,
    EmailTranslationsViewComponent,
    EditKeywordComponent,
    EditCategoryComponent,
    DescriptionsViewComponent,
    TeamsViewComponent,
    EditTeamComponent,
    EditSupporterComponent,
    SafePipe,
    TeamsFiltersComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownsModule,
    NgbModule,
    DialogModule,
    EditorModule,
    ToolBarModule,
    TranslationModule
  ],
  entryComponents: [
    EditKeywordComponent,
    EditCategoryComponent,
    EditTeamComponent,
    EditSupporterComponent
  ],
  providers: [
    CanDeactivateGuard,
    TeamsViewService,
    TranslatePipe
  ]
})
export class AdminViewModule { }
